import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = '' }: MovieCardProps) {
  const isSeries = movie.type === 'series';
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block cursor-pointer rounded-lg bg-background-100 border border-background-200 overflow-hidden transition-all duration-300 hover:border-primary-400/60 hover:-translate-y-1 ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-300">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 午夜视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-background-950/80 text-[11px] font-medium text-secondary-300 backdrop-blur-sm">
          {movie.typeLabel}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary-500 text-[11px] font-bold text-background-950">
          <i className="ri-star-fill text-[11px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background-950 to-transparent opacity-90" />
        <span className="absolute bottom-2 left-2 right-2 flex items-center gap-1 text-[11px] text-secondary-300">
          <i className="ri-map-pin-line text-xs"></i>
          {movie.region}
          <span className="mx-1 text-background-400">·</span>
          {movie.year}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-400 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 2).map((g) => (
            <span key={g} className="px-2 py-0.5 rounded-full bg-secondary-100/10 text-secondary-300 text-[11px]">
              {g}
            </span>
          ))}
          {isSeries && (
            <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-300 text-[11px]">
              剧集
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}